import _ from "lodash";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

const Number = ({max, min, className, ...otherProps}) => {

    // Create a debounced version of onBlur (where saving happens...)
    const onBlurDebounced = useCallback(_.debounce(() => {
        otherProps.onBlur();
    }, 2000), []);

    // When a change happens, do the change, then trigger the debounced saving...
    const onChange = (e) => {
        otherProps.onChange(e);
        onBlurDebounced();
    };

    // When leaving the field and onBlur happens, do the saving now and cancel any queued up saves...
    const onBlur = () => {
        otherProps.onBlur();
        onBlurDebounced.cancel();
    }

    const classes = classNames(
        className,
        "block sm:text-sm",
        "shadow-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
    );

    return <input
        max={max}
        min={min}
        type='number'
        className={classes}
        value={otherProps.value}
        onChange={onChange}
        onBlur={onBlur}
    />;
}

Number.propTypes = {
    value: PropTypes.string.isRequired,

    max: PropTypes.number,
    min: PropTypes.number,

    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

Number.defaultProps = {
    max: 600,
    min: 0
};

export default Number;
